import './GlobalStyles.module.css';

function GlobalStyles({ children }) {
    return children;
}

export default GlobalStyles;


